import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.deepOrange[900],
    main: colors.deepOrange[500],
    light: colors.deepOrange[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange['A400'],
    light: colors.orange['A400']
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[700],
    link: colors.blue[700]
  },
  background: {
    default: white, //'#F4F6F8',
    paper: white
  },
  icon: colors.blueGrey[700],
  divider: colors.grey[200]
};
